import styled, { css } from 'styled-components';
import { devices } from '../../../../utils/responsive';

export const Content = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  flex-wrap: wrap;

  fuel-tooltip {
    text-transform: none;
  }
`;

export const WrapperAlignRigth = styled.div`
  margin-left: auto;
`;

export const WrapperNewLineMobile = styled.div`
  ${({ theme }) => css`
    margin-left: ${theme.spacing.km2};

    @media ${devices.mobile} {
      flex: 1 1 100%;
      margin-top: ${theme.spacing.km4};
      justify-content: flex-end;
      display: flex;
    }
  `}
`;

export const ShieldLockIcon = styled.img`
  ${({ theme }) => css`
    width: ${theme.spacing.km4};
    height: ${theme.spacing.km4};
    color: ${theme.color.support.blue.strong};
  `}
`;
